import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { getSubscriptionOptionList } from "../../../../AdminApi/commFunc";
import { partyInfoFilterState } from "../../../../pages/Party/PartyInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import { partyInfoFilterState_Youtube_World } from "../../../../pages/Party/PartyInfo_Youtube_World";

interface PartyInfoFilterProps {
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  filteringValue: {
    servsubsid: string;
    state: number;
    isFull: number;
    isSecret: number;
    isClicked: boolean;
  };
  setFilteringValue: any;
  setPage: Dispatch<SetStateAction<number>>;
}

interface SPartyInfoFilterContainer {
  maxWidth?: number;
}

// 파티 상태 옵션
export const partyStateOption = [
  { value: "0", label: "종료" },
  { value: "1", label: "진행중" },
  { value: "2", label: "해산 처리중" },
  { value: "3", label: "해산" },
  { value: "10", label: "예정" },
];

// 모집 상태 옵션
export const memberStateOption = [
  { value: "0", label: "모집중" },
  { value: "1", label: "모집 완료" },
];

// 시크릿 상태 옵션
export const secretModeOption = [
  { value: "1", label: "켜짐" },
  { value: "0", label: "꺼짐" },
];

export default function PartyInfoFilter_Youtube({
  setSearchValue,
  filteringValue,
  setFilteringValue,
  setPage,
}: PartyInfoFilterProps) {
  const [partyInfoFilter, setPartyInfoFilter] =
    useRecoilState(partyInfoFilterState_Youtube_World);
  const [subsDropdownValue, setSubsDropdownValue] = useState<OptionType>({
    value:
      partyInfoFilter?.subsid?.value !== ""
        ? partyInfoFilter?.subsid?.value
        : "",
    label:
      partyInfoFilter?.subsid?.value !== ""
        ? partyInfoFilter?.subsid?.label
        : "Subscription 선택",
  });
  const [partyStateValue, setPartyStateValue] = useState<OptionType>({
    value:
      partyInfoFilter?.state?.value !== 100
        ? `${partyInfoFilter?.state?.value}`
        : "",
    label:
      partyInfoFilter?.state?.value !== 100
        ? `${partyInfoFilter?.state?.label}`
        : "파티 상태",
  });
  const [memberStateValue, setMemberStateValue] = useState<OptionType>({
    value:
      partyInfoFilter?.isFull?.value !== 10
        ? `${partyInfoFilter?.isFull?.value}`
        : "",
    label:
      partyInfoFilter?.isFull?.value !== 10
        ? partyInfoFilter?.isFull?.label
        : "모집 상태",
  });
  const [secreteStateValue, setSecretStateValue] = useState<OptionType>({
    value:
      partyInfoFilter?.isSecret?.value !== 10
        ? `${partyInfoFilter?.isSecret?.value}`
        : "",
    label:
      partyInfoFilter?.isSecret?.value !== 10
        ? partyInfoFilter?.isSecret?.label
        : "시크릿 상태",
  });

  // subscription 선택 옵션
  const subsOptionList = getSubscriptionOptionList(true);

  useEffect(() => {}, [
    filteringValue,
    subsDropdownValue,
    partyStateValue,
    memberStateValue,
    secreteStateValue,
  ]);

  return (
    <PartyInfoFilterContainer>
      <Search
        placeholder="PID 입력"
        setSearchValue={setSearchValue}
        isDisabled={false}
        defaultValue={
          partyInfoFilter?.searchValue !== ""
            ? partyInfoFilter?.searchValue
            : undefined
        }
        pageResetEvent={() => setPage(0)}
        inputType="number"
      />

      <FilterContainer>
        <>
          <Flex gapSize={10}>
            <>
              <Flex gapSize={5}>
                <>
                  <FilterIcon />

                  <DropDown
                    isDisabled={false}
                    initText="Subscription 선택"
                    setDropDownValue={setSubsDropdownValue}
                    optionList={subsOptionList}
                    dropdownValue={subsDropdownValue}
                  />
                </>
              </Flex>

              <DropDown
                isDisabled={false}
                initText="파티 상태"
                setDropDownValue={setPartyStateValue}
                optionList={partyStateOption}
                boxWidth={120}
                dropdownValue={partyStateValue}
              />

              <DropDown
                isDisabled={false}
                initText="모집 상태"
                setDropDownValue={setMemberStateValue}
                optionList={memberStateOption}
                boxWidth={120}
                dropdownValue={memberStateValue}
              />

              <DropDown
                isDisabled={false}
                initText="시크릿 상태"
                setDropDownValue={setSecretStateValue}
                optionList={secretModeOption}
                boxWidth={120}
                dropdownValue={secreteStateValue}
              />
            </>
          </Flex>

          <Flex gapSize={10}>
            <>
              <ConfirmBtn
                btnText="적용"
                btnColor="mint"
                btnHeight={38}
                btnClickEvent={() => {
                  setPage(0);
                  setFilteringValue({
                    ...filteringValue,
                    isClicked: true,
                    servsubsid:
                      subsDropdownValue?.value !== ""
                        ? Number(subsDropdownValue?.value)
                        : "",
                    state:
                      partyStateValue?.value !== ""
                        ? Number(partyStateValue?.value)
                        : 100,
                    isFull: memberStateValue?.value
                      ? Number(memberStateValue?.value)
                      : 10,
                    isSecret: secreteStateValue?.value
                      ? Number(secreteStateValue?.value)
                      : 10,
                  });
                }}
                isDisabled={
                  subsDropdownValue?.value === "" &&
                  partyStateValue?.value === "" &&
                  memberStateValue?.value === "" &&
                  secreteStateValue?.value === ""
                }
              />

              <LineBtn
                btnText="초기화"
                icon="refresh"
                btnHeight={38}
                btnColor="mint"
                disabled={
                  subsDropdownValue?.value === "" &&
                  partyStateValue?.value === "" &&
                  memberStateValue?.value === "" &&
                  secreteStateValue?.value === ""
                }
                btnClickEvent={() => {
                  setSubsDropdownValue({
                    value: "",
                    label: "Subscription 선택",
                  });
                  setPartyStateValue({
                    value: "",
                    label: "파티 상태",
                  });
                  setMemberStateValue({
                    value: "",
                    label: "모집 상태",
                  });
                  setSecretStateValue({
                    value: "",
                    label: "시크릿 상태",
                  });
                  setFilteringValue({
                    isClicked: false,
                    servsubsid: "",
                    state: 100,
                    isFull: 10,
                    isSecret: 10,
                  });

                  setPartyInfoFilter({
                    ...partyInfoFilter,
                    subsid: {
                      value: "",
                      label: "Subscription 선택",
                    },
                    state: {
                      value: 100,
                      label: "파티 상태",
                    },
                    isFull: {
                      value: 10,
                      label: "모집 상태",
                    },
                    isSecret: {
                      value: 10,
                      label: "시크릿 상태",
                    },
                    page: -1,
                  });
                }}
              />
            </>
          </Flex>
        </>
      </FilterContainer>
    </PartyInfoFilterContainer>
  );
}

export const PartyInfoFilterContainer = styled.div<SPartyInfoFilterContainer>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media screen and (max-width: ${({ maxWidth }) => maxWidth ?? 1400}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FilterContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  @media screen and (max-width: 1400px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
